/**
 * Data hook for the Client Success Coverage tab (ADR-0101).
 *
 * useCoverage() — polls GET /api/firm-success/coverage every 30s. Read-only;
 * the coverage matrix tolerates mild staleness (same posture as the firm
 * roster — a glance, not a read-after-write gate). The payload is bounded
 * (one row per firm × state × case type — low hundreds) so refetching the
 * whole thing is cheap.
 */

import { CoverageResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useCoverage = createPollingQuery({
  queryKey: ["firm-success", "coverage"] as const,
  path: "/api/firm-success/coverage",
  schema: CoverageResponseSchema,
  refetchIntervalMs: 30_000,
});
